import { useCallback } from 'react';
import { useLogAnalyticsEvent } from 'shared/src/hooks';

type LogClickRenameFolderParams = {
  folderSno: number;
};

export const useLogClickRenameFolder = () => {
  const logAnalyticsEvent = useLogAnalyticsEvent();

  return useCallback(
    ({ folderSno }: LogClickRenameFolderParams) => {
      logAnalyticsEvent({
        name: 'CLICK_RENAME_FOLDER',
        analytics: {
          FOLDER_SNO: folderSno.toString(),
        },
      });
    },
    [logAnalyticsEvent],
  );
};
